var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M107.6 38.4c-1.6-1.6-3.7-2.4-5.7-2.4-2.1 0-4.1.8-5.7 2.4l-5.9 5.9-5.9-5.9c-1.6-1.6-3.7-2.4-5.7-2.4-2.1 0-4.1.8-5.7 2.4-3.2 3.1-3.2 8.2 0 11.4l5.9 5.9-9.9 9.7-9.8-9.8 5.9-5.9c3.2-3.2 3.2-8.4-.2-11.5-1.5-1.4-3.5-2.1-5.4-2.1-2.2 0-4.4.9-6.1 2.5l-5.7 5.6-5.9-5.9c-1.6-1.6-3.7-2.4-5.7-2.4s-4.1.8-5.7 2.4c-3.2 3.1-3.2 8.2 0 11.4l11.8 11.7L60.9 80v28h16.2V80l30.5-30.3c3.2-3.1 3.2-8.2 0-11.3zM40 53.6l-6.8-6.7c-1.6-1.6-1.6-4.1 0-5.7.8-.8 1.8-1.2 2.9-1.2 1.1 0 2.1.4 2.9 1.2l5.9 5.9-2.7 2.7c-1.2 1.1-1.9 2.4-2.2 3.8zm64.8-6.7l-28 27.8c-.4-1.4-1.1-2.7-2.2-3.8l-2.8-2.8 12.6-12.6-8.8-8.7c-1.6-1.6-1.6-4.1 0-5.7.8-.8 1.8-1.2 2.9-1.2s2.1.4 2.9 1.2l8.8 8.7 8.8-8.7c.8-.8 1.8-1.2 2.9-1.2s2.1.4 2.9 1.2c1.6 1.7 1.6 4.2 0 5.8z"}));
}

Icon.defaultProps = {"viewBox":"0 0 138 138"};

module.exports = Icon;

Icon.default = Icon;
